import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62fc302a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "attachment" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "preview-other"
}
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "link" }
const _hoisted_7 = { class: "size" }

import { Attachment, AttachmentTypes } from '@/store/chats/types';
import { getFileSize } from "@/utils/attachment";
import { getShortenedString } from "@/utils/modifiers";
import { IconType } from "@/types/icons";
import Icon from "@/components/icons/Icon/Icon.vue"

interface Props {
    attachment: Attachment
    removeAttachment: (id: string | undefined) => void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InputAttachmentPreview',
  props: {
    attachment: {},
    removeAttachment: { type: Function }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.attachment.url && _ctx.attachment.type === _unref(AttachmentTypes).IMAGE)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.attachment.url,
          class: "preview-image"
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(Icon, {
              icon: _unref(IconType).FILE
            }, null, 8, ["icon"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(getShortenedString)(_ctx.attachment.filename, 6)), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getFileSize)(_ctx.attachment?.size || 0)), 1)
          ])
        ])),
    _createVNode(Icon, {
      icon: _unref(IconType).CROSS_SMALL,
      class: _normalizeClass(["btn-remove", {
            shadow: !(
                _ctx.attachment.url && _ctx.attachment.type === _unref(AttachmentTypes).IMAGE
            ),
        }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeAttachment(_ctx.attachment.id)))
    }, null, 8, ["icon", "class"])
  ]))
}
}

})